import { useDeviceDetect } from '@/utils/useMediaQuery';
import { cn } from '@/utils/utils';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@shelflix/ui-web/components/ui/dialog';
import { ReactNode } from 'react';

interface AlertModalProps {
  openModal: boolean;
  onOpenChange: (open: boolean) => void;
  icon: ReactNode;
  title: string;
  subtitle: string;
  content: ReactNode;
  actionBotton: ReactNode;
}

export function AlertModal({
  openModal = false,
  onOpenChange,
  icon,
  title,
  subtitle,
  content,
  actionBotton,
}: AlertModalProps) {
  const { isMobile } = useDeviceDetect();
  return (
    <Dialog open={openModal} onOpenChange={onOpenChange}>
      <DialogContent className={cn('w-full p-12', isMobile ? 'max-w-[90vw] border-20' : 'max-w-[400px]')}>
        <DialogHeader className="mb-4 flex flex-col items-center gap-4">
          <div className="bg-secondary flex h-16 w-16 items-center justify-center rounded-sm">{icon}</div>

          <DialogTitle className="text-primary font-semibold">{title}</DialogTitle>
          <DialogDescription className="text-center">{subtitle}</DialogDescription>
        </DialogHeader>

        {content}

        <div className="w-full">{actionBotton}</div>
      </DialogContent>
    </Dialog>
  );
}
